import { API } from "@swivl-mono/api-helper";
import { UserInterface } from "@swivl-mono/types";
import { DateTime } from "luxon";
import { useState } from "react";

interface Props {
  expiresAt?: Date;
  user: UserInterface;
}

export default function RenewButton(props: Props): React.ReactNode {
  const { user, expiresAt } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const renewLink = async (): Promise<void> => {
    setIsLoading(true);
    try {
      await API.Users.renewTranscriptAccess(user.orgId, user.id);
      window.location.reload();
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <div className="TranscriptRenewButton">
      <div className="expiresText">{expiresAt ? <>Link Expires {DateTime.fromJSDate(expiresAt).toRelative()}</> : "Link Expired"}</div>
      <div className="renewButton">
        <div onClick={() => !isLoading && renewLink()}>{isLoading ? "Renewing..." : "Renew Link?"}</div>
      </div>
    </div>
  );
}
